import applicationDrafts from './applicationDrafts';

const applicationDraftService = [
    {
        matcher: 'applicationDrafts',
        reply: config => {
            return [200, applicationDrafts];
        }
    },
    {
        matcher: /applicationDrafts\/(.*)/,
        reply: config => {
            const id = /applicationDrafts\/(.*)/.exec(config.url)[1];
            const draft = applicationDrafts.find(draft => draft.id === id);
            return [200, draft];
        }
    }
]

export default applicationDraftService;